function normalizeDomain(domain: string): string {
  return domain
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "") // remove protocol
    .replace(/\/.*$/, "") // remove path
    .replace(/:\d+$/, ""); // ✅ remove port
}

function isDomainAllowed(
  allowedDomains: string[] | null | undefined,
  currentHost: string,
): boolean {
  if (!allowedDomains || allowedDomains.length === 0) return false;

  const current = normalizeDomain(currentHost);

  return allowedDomains.some((d) => {
    const allowed = normalizeDomain(d);

    // Exact match
    if (current === allowed) return true;

    // Subdomain match (*.example.com)
    if (allowed.startsWith("*.")) {
      const root = allowed.slice(2);
      return current === root || current.endsWith(`.${root}`);
    }

    return false;
  });
}

function getWidgetHost(): string {
  // Detect if running in an iframe
  const isIframe = window.self !== window.top;

  if (isIframe && document.referrer) {
    try {
      return new URL(document.referrer).hostname;
    } catch {
      // Fallback
    }
  }

  return window.location.hostname;
}

export { normalizeDomain, isDomainAllowed, getWidgetHost };
